const { hostname, origin } = window.location;

const config = {
  apiURL: process.env.REACT_APP_API_URL,
  IdentityClientID: hostname,
  OriginUrl: origin,
};

export { config as default };
